'use client';

import { RegistryContext, RegistryProvider, useAtomMount } from '@effect/atom-react';
import { Option } from 'effect';
import type * as AtomRegistry from 'effect/unstable/reactivity/AtomRegistry';
import { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';

import type { AnnouncementAtoms } from '@vs-shop/engine/atom/announcements/announcementAtoms';

type AnnouncementScopeValue = {
  readonly registry: AtomRegistry.AtomRegistry;
  readonly atoms: AnnouncementAtoms;
};
export const AnnouncementContext = createContext<Option.Option<AnnouncementScopeValue>>(
  Option.none()
);

// The announcement registry survives replacement of the locale-keyed registry.
export function AnnouncementScope({
  children,
  atoms,
}: {
  readonly children: ReactNode;
  readonly atoms: AnnouncementAtoms;
}) {
  const registry = useContext(RegistryContext);
  useAtomMount(atoms.snapshot);
  const scope = useMemo(() => Option.some({ registry, atoms }), [registry, atoms]);
  return <AnnouncementContext value={scope}>{children}</AnnouncementContext>;
}

export function AnnouncementProvider({
  children,
  atoms,
}: {
  readonly children: ReactNode;
  readonly atoms: AnnouncementAtoms;
}) {
  return (
    <RegistryProvider>
      <AnnouncementScope atoms={atoms}>{children}</AnnouncementScope>
    </RegistryProvider>
  );
}
